export const getUnresolvedRevenueEventNotice = (meta = {}) => {
  const count = Number(meta?.unresolved_event_document_count);
  if (!Number.isFinite(count) || count <= 0) return null;
  return `Trong phạm vi đang xem, có ${count.toLocaleString('vi-VN')} chứng từ chưa xác định ngày ghi nhận; cảnh báo theo ngày hạch toán trong kỳ đã chọn. Các chứng từ này chưa tính vào doanh thu theo kỳ.`;
};
